import { useCallback } from 'react';

import { useEventListener } from '.';

const ESCAPE_KEYS = ['27', 'Escape'];

export const useOnEscapeKey = (handler: () => void) => {
  const handleEscapeKeyClose = useCallback(
    ({ key }) => {
      if (ESCAPE_KEYS.indexOf(String(key)) !== -1) {
        handler();
      }
    },
    [handler]
  );

  useEventListener('keyup', handleEscapeKeyClose);
};
